<template>
  <div class="row">
    <div class="col-md-12 px-0">
      <ol class="breadcrumb smaller-font-content">
        <li v-for="(crumb, key) in crumbs" v-if="crumb.meta && crumb.meta.title" :key='key'
        :class="{
          'breadcrumb-item': true,
          'active': key === (crumbs.length - 1) }">
          <router-link v-if="key !== (crumbs.length - 1)" :to="crumb.path" :class="{'breadcrumb-first-item': key === 0}">{{ crumb.meta.title }}</router-link>
          <span v-else>{{ crumb.meta.title }}</span>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      crumbs: [],
    };
  },
  created() {
    for (let i = 0; i < this.$route.matched.length; i += 1) {
      this.crumbs.push(this.$route.matched[i]);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/presentational/widgets/Breadcrumbs.vue?bc35f544